/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

export default freeGlobal;



//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/lodash-es/_freeGlobal.js
// module id = 126
// module chunks = 0